import { Injectable } from '@angular/core';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { jsPDF } from "jspdf"
import html2canvas from 'html2canvas';
import { SSL_OP_SSLEAY_080_CLIENT_DH_BUG } from 'constants';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor(private _fuseProgressBarService: FuseProgressBarService) { }

  cleanSameStart= function(a:string, b:string):number{

    var posicion = 0;

    for(var i=0;i<a.length;i++){
      if(a[i]===b[i])
        posicion++;
    }

    return posicion;

  }

  sortAlphaNum(a, b):any {

    var reA = /[^a-zA-Z]/g;
    var reN = /[^0-9]/g;

    if(typeof a =="object" && 'nombre' in a)
      a = a.nombre;

    if(typeof b =="object" && 'nombre' in b)
      b = b.nombre;

    
    var posicion = 0;

    for(var i=0;i<a.length;i++){
      if(a[i]===b[i]){
        posicion++;
      }else{
        break;
      }
    }

    //var posicionIgual = this.cleanSameStart(a,b);
    if(posicion>0 && posicion==a.length-1)
      posicion = posicion-1;

    a = a.substring(posicion,a.length).trim();
    b = b.substring(posicion,b.length).trim();

    var espacioA = a.indexOf(" ", 10);

    if(espacioA==-1)
      espacioA = a.length;

    var espacioB = b.indexOf(" ", 10);

    if(espacioB==-1)
      espacioB = b.length;

    a = a.substring(0, espacioA);
    b = b.substring(0, espacioB);

    var aA = a.replace(reA, "");
    var bA = b.replace(reA, "");
    var aN = a.replace(reN, "");
    var bN = b.replace(reN, "");
    //a.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g,' ');
    //b.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g,' ');
    var startsWihNumber = !isNaN(a[0]) || !isNaN(b[0]);

    if(startsWihNumber){
      if(!isNaN(a[0]) && !isNaN(b[0]) && a[0]!=b[0]){
        const regex = /^[0-9][0-9]*/g;
        var aNC = parseInt(a.match(regex)[0]);
        var bNC = parseInt(b.match(regex)[0]);
        return aNC>bNC ? 1 : -1;
      }


      if(isNaN(a[0]))
        return -1;

      if(isNaN(b[0]))
        return 1;
    }

    if (aA === bA || startsWihNumber) {
      var aN = a.replace(reN, "");
      var bN = b.replace(reN, "");
      //Si los dos son numeros enteros que compare los numeros
      if(!isNaN(aN) && !isNaN(bN)){
        aN = parseInt(aN);
        bN = parseInt(bN);
      }

      return aN === bN ? 0 : aN > bN ? 1 : -1;
    } else {
      return aA > bA ? 1 : -1;
    }
  }

  

  async printPdf()
  {

    this._fuseProgressBarService.show();
    //alert("Processing pdf export..."+"\n "+"This can take some minutes.");

    let pdfContent =  null;
    let contentLength = 0;

    pdfContent = document.getElementsByClassName("print");
    contentLength = pdfContent.length;

    var pdf = new jsPDF('p', 'mm','a4');
    pdf.setFontSize(8);
    pdf.setTextColor(0,0,0,.60);
    var position = 0;
    var pagePosition = 10;
    var pageNumber = 0;

    pageNumber = this.printFooter(pdf,pageNumber);
  
    const options = {
      pagesplit: true
    };

    for (let i = 0;i  <= pdfContent.length; i++){
      await html2canvas((pdfContent[i] as HTMLElement),{scale:3/3}).then(canvas => {
          console.log("Agregando imagen");

          var proporcion = canvas.width/200;
          var heightImage = canvas.height/proporcion;
          var nextHeight = pagePosition+heightImage;

          if(nextHeight>270){
            pdf.addPage();
            pdf.setPage(i+1);
            pageNumber = this.printFooter(pdf,pageNumber);
            console.log("Se agrego una pagina al pdf");
            pagePosition = 10;
          }

          if(heightImage>0){
            pdf.addImage(canvas.toDataURL("images/png", 1), 'PNG', 5,pagePosition, 200, heightImage);
            pagePosition += heightImage+2;

            console.log("Se agrego la imagen");
          }
          // if (i == contentLength-1){
          //      pdf.save('results.pdf');
          //      console.log("Se imprimio el pdf");
          // }else{
            if(pagePosition>270){
                pdf.addPage();
                pdf.setPage(i+1);
                //pdf.text(i+1+'',150,285); //print number bottom right
                pageNumber  = this.printFooter(pdf,pageNumber);
                console.log("Se agrego una pagina al pdf");
                pagePosition = 10;
            }
         // }
      }).then(()=>{
          if (i == contentLength-1){
            pdf.save('results.pdf');
            console.log("Se imprimio el pdf");
            this._fuseProgressBarService.hide();
          }
        }   
      );
    }

    //pdf.save('results.pdf');
    //console.log("Se imprimio el pdf");

    this._fuseProgressBarService.hide();

  }

  private printFooter(document:any,pageNumber:number):number{

    pageNumber +=1;
    document.text('Página ' + String(pageNumber), document.internal.pageSize.width -20, 287, {
      align: 'right'
    })

    return pageNumber;

  }


  
}
